export const ONBOARDING_DONE_EVENT = 'blinkr:onboarding:done';
export const ONBOARDING_STORAGE_KEY = 'blinkr:onboarding:v4';
const ONBOARDING_SESSION_DONE_KEY = 'blinkr:onboarding:session-done';

export function onboardingStorageKey(): string {
  const tgUserId = window.Telegram?.WebApp?.initDataUnsafe?.user?.id;
  return tgUserId ? `${ONBOARDING_STORAGE_KEY}:${tgUserId}` : ONBOARDING_STORAGE_KEY;
}

export function shouldForceOnboarding(): boolean {
  const fromQuery = new URLSearchParams(window.location.search).get('onboarding') === '1';
  const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
  return fromQuery || startParam === 'onboarding' || startParam === 'onboarding_1';
}

export function shouldBlockInitialDataLoad(): boolean {
  try {
    const key = onboardingStorageKey();
    if (window.sessionStorage.getItem(ONBOARDING_SESSION_DONE_KEY) === '1') return false;
    return shouldForceOnboarding() || window.localStorage.getItem(key) !== 'done';
  } catch {
    return true;
  }
}

export function markOnboardingDone(storageKey = onboardingStorageKey()): void {
  try {
    window.localStorage.setItem(storageKey, 'done');
    window.sessionStorage.setItem(ONBOARDING_SESSION_DONE_KEY, '1');
  } catch {
    // Ignore storage failures in embedded webviews.
  }
  window.dispatchEvent(new Event(ONBOARDING_DONE_EVENT));
}
